<template>
    <div>
        <Checkbox2 :disabled="inputDisabled" v-model="mergeAffiliations">
            {{ translate("page.admin_academy_results.count_by_affiliations") }}
        </Checkbox2>

        <Checkbox2 :disabled="inputDisabled" v-model="showExAequoPlaces">
            {{ translate("page.admin_academy_results.show_ex_aequo") }}
        </Checkbox2>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import Checkbox2 from "../Common/Checkbox2.vue";
    import { getOptionsFromState, storeOptionsInLocalStorage, useAcademyResultsStore } from "./academyResultsStore";

    const academyResultsStore = useAcademyResultsStore();

    const mergeAffiliations = computed({
        get() {
            return academyResultsStore.mergeAffiliations;
        },
        set(value) {
            academyResultsStore.mergeAffiliations = value;
            storeOptionsInLocalStorage(academyResultsStore.eventId, getOptionsFromState(academyResultsStore));
        },
    });
    const showExAequoPlaces = computed({
        get() {
            return academyResultsStore.showExAequoPlaces;
        },
        set(value) {
            academyResultsStore.showExAequoPlaces = value;
            storeOptionsInLocalStorage(academyResultsStore.eventId, getOptionsFromState(academyResultsStore));
        },
    });

    const inputDisabled = computed(() => academyResultsStore.publishingMode);
</script>

<style scoped></style>
